import React from 'react';
import { Button, Tile, InlineLoading } from '@carbon/react';
import { Locked, ArrowRight } from '@carbon/icons-react';
import { useTheme } from '../context/ThemeContext';
import { useSubscription } from '../hooks/useSubscription';

const SubscriptionGate = ({ 
  children, 
  feature = "this feature",
  showUpgradeButton = true,
  customMessage = null,
  disabled = false,
  showChildrenGreyed = false,
}) => {
  const { theme } = useTheme();
  const { loading, hasActiveSubscription, subscriptionRequired } = useSubscription();
  const isDark = theme === 'dark';
  const bgPrimary = isDark ? '#161616' : '#ffffff';
  const textPrimary = isDark ? '#f4f4f4' : '#161616';
  const textSecondary = isDark ? '#c6c6c6' : '#525252';
  const borderColor = isDark ? '#393939' : '#e0e0e0';

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '32px' }}>
        <InlineLoading />
      </div>
    );
  }

  if (hasActiveSubscription || !disabled) {
    return children;
  }

  const gateContent = (
    <Tile style={{ 
      backgroundColor: bgPrimary,
      border: `1px solid ${borderColor}`,
      borderRadius: '12px',
      padding: '32px',
      textAlign: 'center',
      margin: '16px 0'
    }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        marginBottom: '16px' 
      }}>
        <Locked size={48} style={{ color: '#0f62fe' }} />
      </div>
      
      <h3 style={{ 
        fontSize: '1.25rem', 
        fontWeight: '600', 
        marginBottom: '12px',
        color: textPrimary
      }}>
        Subscription Required
      </h3>
      
      <p style={{ 
        color: textSecondary, 
        marginBottom: '24px',
        lineHeight: '1.5'
      }}>
        {customMessage || 
          `You need an active subscription to access ${feature}. Choose a plan that fits your needs and start monitoring your cold chain today.`
        }
      </p>

      {showUpgradeButton && (
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button 
            kind="primary" 
            size="lg"
            renderIcon={ArrowRight}
            onClick={() => window.location.href = '/pricing'}
          >
            Choose a Plan
          </Button>
          <Button 
            kind="secondary" 
            size="lg"
            onClick={() => window.location.href = '/dashboard/subscription'}
          >
            View Subscriptions
          </Button>
        </div>
      )}
    </Tile>
  );

  if (showChildrenGreyed) {
    return (
      <>
        {gateContent}
        <div style={{
          opacity: 0.45,
          filter: 'grayscale(70%)',
          pointerEvents: 'none',
          userSelect: 'none',
          position: 'relative',
        }}>
          {children}
        </div>
      </>
    );
  }

  return gateContent;
};

export default SubscriptionGate;
